import React from "react";
import { Dialog } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { FaRegCopy } from "react-icons/fa";
import QRCode from "react-qr-code";
import { QRCodeDialogProps } from "../../Types/types";
import { styled } from "@mui/system";

const CustomDialog = styled(Dialog)(() => ({
  "& .MuiPaper-root": {
    borderRadius: "20px",
  },
  "& .MuiBackdrop-root": {
    backgroundColor: "rgba(88, 110, 223, .8)",
  },
}));

const QRCodeDialog: React.FC<QRCodeDialogProps> = ({
  open,
  onClose,
  guideId,
  language,
  guideTitle,
  handleCopyToClipboard,
}) => {
  const shareUrl = `${window.location.origin}/selected/detail/${guideId}?lang=${language}`;

  return (
    <CustomDialog open={open} onClose={onClose} className="font-sans">
      <div className="bg-lightPurple p-2 px-4 sm:p-6 sm:px-10 overflow-x-hidden rounded-2xl relative">
        <button
          onClick={onClose}
          className="bg-white rounded-full p-2 pt-1.5 absolute right-2 top-2 opacity-100 *:opacity-50 *:hover:opacity-100 transition-all"
        >
          <CloseIcon />
        </button>
        <h2 className="text-center text-3xl font-bold text-purple my-8">
          {guideTitle}
        </h2>
        <div className="sm:p-6 p-4 bg-white rounded-lg mb-8">
          <div className="flex justify-center">
            <QRCode value={shareUrl} />
          </div>
        </div>

        <div className="flex justify-between items-center space-x-2">
          <span className="text-sm text-gray-100 truncate">{shareUrl}</span>
          <button
            className="bg-white p-3 rounded opacity-100 *:opacity-50 *:hover:opacity-100 transition-all"
            onClick={handleCopyToClipboard}
          >
            <FaRegCopy className="size-5" />
          </button>
        </div>
      </div>
    </CustomDialog>
  );
};

export default QRCodeDialog;
